<template>
    <div>
      <!-- NAVBAR -->
      <my-navbar :controller="controller" />

      <!-- HEADER -->
      <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8 hide">
        <div class="container-fluid">
          <div class="header-body">
            <div class="row">
              <!-- CONTENIDO HEADER -->
            </div>
          </div>
        </div>
      </div>

      <!-- CONTENT -->
      <div class="container-fluid mt--7">
        <div class="row">
          <div class="col">
            <!-- COMPONENTE PRINCIPAL -->
            <div class="row">
              <div class="col-lg-12">
                <div class="wrapper">
                  <div class="ui-sys-msg badges-container">
                      <my-spinner :loading="loading"></my-spinner>
                      <div id="dealer-badges"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>
<script>
  export default {
    name: "badges",
    data() {
      return {
        ownerIdentifier: process.env.VUE_APP_OWNER_IDENTIFIER,
        serviceIdentifier: process.env.VUE_APP_BADGES_IDENTIFIER,
        loading: false,
        controller: {
          title: "Dealer Badges",
          mainRouter: "/"
        }
      };
    },
    beforeDestroy() {
      this.$unloadScript(`${process.env.VUE_APP_BADGES_ASSETS}/chunk-vendors.js`);
      this.$unloadScript(`${process.env.VUE_APP_BADGES_ASSETS}/app.js`);
    },
    mounted() {
      this.loadPlugins()
    },
    methods: {
      loadPlugins() {
        
        const v = new Date().getDate();

        const { ownerIdentifier, serviceIdentifier} = this;
        const vendors = `${process.env.VUE_APP_BADGES_ASSETS}/chunk-vendors.js?v=${v}`;
        const app = `${process.env.VUE_APP_BADGES_ASSETS}/app.js?v=${v}`;

        this.$loadScript(vendors).then(()=> {
          this.$loadScript(app).then(() => {
            DealerBadgesPlugin.init({
                ownerIdentifier,
                serviceIdentifier,
                tenant: 'chileautos'
            })
          })
        })

      }
    }
  };
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
}
.badges-container {
    max-width: 800px!important;
    text-align: left;
    position: relative;
}
</style>